import * as React from 'react';
import * as global_constant from '../../global_constants';

// TypeScript: declare the Salesforce bootstrap on window
declare global {
    interface Window {
        embeddedservice_bootstrap: any;
    }
}

interface EmbeddedMessagingChatProps {
    userData?: {
        first_name?: string;
        last_name?: string;
        email?: string;
    };
}

class EmbeddedMessagingChatComponent extends React.Component<EmbeddedMessagingChatProps> {

    componentDidMount() {
        if (!global_constant.sf_chat_config) {
            console.error('sf_chat_config is undefined or null. Chat component will not initialize.');
            return;
        }

        //Adding custom style fro chat service
        this.addCustomChatStyles();

        // Only load the script if it hasn't been loaded yet
        if (!window.embeddedservice_bootstrap) {
            const script = document.createElement('script');
            script.src = `${global_constant.sf_chat_config.chat_url}/assets/js/bootstrap.min.js`;
            script.onload = () => {
                this.initEmbeddedMessaging();
            };
            document.body.appendChild(script);
        } else {
            console.log("----- Chat service has already loaded 'embeddedservice_bootstrap' -----");
        }
    }

    addCustomChatStyles = () => {
        const customCssUrl = '/chat/salesforce_chat.css';
        const existingLink = document.head.querySelector(`link[href="${customCssUrl}"]`);
        if (existingLink) {
            console.log("Custom chat stylesheet already loaded, skipping addition.");
            return;
        }

        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = customCssUrl;
        document.head.appendChild(link);
    };

    initEmbeddedMessaging = () => {
        const userData = this.props.userData || {};
        window.embeddedservice_bootstrap.settings.language = 'en_US';
        window.embeddedservice_bootstrap.settings.entryFeature = {
            globalButton: {
                enabled: false,
            }
        };

        window.addEventListener("onEmbeddedMessagingReady", () => {
            console.log("Starting the event onEmbeddedMessagingReady ....");
            window.embeddedservice_bootstrap.prechatAPI.setVisiblePrechatFields({
                "_firstName": { "value": userData.first_name || "", "isEditableByEndUser": false },
                "_lastName": { "value": userData.last_name || "", "isEditableByEndUser": false },
                "_email": { "value": userData.email || "", "isEditableByEndUser": true }
            });
            window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({ "ProductField": global_constant.sf_chat_config.chat_product_field });
        });

        window.embeddedservice_bootstrap.init(
            global_constant.sf_chat_config.chat_id,
            global_constant.sf_chat_config.chat_name,
            global_constant.sf_chat_config.chat_url,
            {
                scrt2URL: global_constant.sf_chat_config.scrt2URL
            }
        );

        window.addEventListener("onEmbeddedMessagingPreChatLoaded", (data) => {
            //Prechat loaded....
        });

        window.addEventListener("onEmbeddedMessagingWindowMinimized", (data) => {
            //Window minimized....
        });

        window.addEventListener("onEmbeddedMessagingWindowMaximized", (data) => {
            //Window maximized....
        });

        window.addEventListener("onEmbeddedMessagingBusinessHoursStarted", (data) => {
            //Business hours started....
            console.log("Business hours started....");
        });

        window.addEventListener("onEmbeddedMessagingBusinessHoursEnded", (data) => {
            //Business hours ended....
            console.log("Business hours ended....");
        });
    }

    render() {
        // Render nothing, just handle script loading and initialization
        return null;
    }
}

export default EmbeddedMessagingChatComponent;
